module.exports = __webpack_public_path__ + "static/img-a422fdb55a5ebcca27203c2852fc2a92.png";